import React, { useEffect, useState } from 'react';
import {
    Picker,
    newDate,
    DatePickerConfig,
    convertDateInstanceToDateObject,
    format
} from '@persian-tools/persian-mobile-datepicker';
import CustomisedTextField from '../textField/textField';
import { IShellConfig } from '../../models/IShellConfig';
import { IDatePicker } from './IDatePicker';
import { MAX_WIDTH_OBJ } from '../../config/cacheKey';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { digitsEnToFa } from '@persian-tools/persian-tools';
import './datePicker.css'
import DatePickerComponents from './datePickerComponents';

export default function CustomisedDatePicker({
    onChange,
    value,
    error,
    helperText,
    label,
    disabled,
    placeHolder,
}: IDatePicker) {
    const [jsonFile, setJsonFile] = useState<IShellConfig>();
    useEffect(() => {
        fetch('/setting/shellConfig.json')
            .then((response) => response.json())
            .then((data) => {
                setJsonFile(data);
            });
    }, []);

    const config: DatePickerConfig = {
        year: {
            // caption: {
            //     text: ' ',
            // },
            formatter({ year }) {
                return digitsEnToFa(year);
            },

        },
        month: {
            // caption: {
            //     text: ' ',
            // },
        },
        day: {
            // caption: {
            //     text: '',
            // },
        },
    };
    const [showPicker, setShowPicker] = React.useState<boolean>(false);
    const [selectedDateValue, setSelectedDateValue] = useState<any>();
    const [selectedDateValueString, setselectedDateValueString] =
        React.useState<string>('');
    useEffect(() => {
        if (value && !selectedDateValue) {
            let date = new Date(value);
            let dateObject = convertDateInstanceToDateObject(date as Date);
            const dateVal = format(date, "yyyy/MM/dd");
            // setSelectedDateValue(dateObject);
            // setselectedDateValueString(
            //     dateObject.year + '/' + dateObject.month + '/' + dateObject.day
            // );
            setSelectedDateValue(dateObject);
            setselectedDateValueString(dateVal);
        }
    }, [value]);

    function handleSubmit(selectedDate: any) {
        const dateVal = format(selectedDate.date, "yyyy/MM/dd");
        // setselectedDateValueString(
        //     selectedDate.object.year +
        //     '/' +
        //     selectedDate.object.month +
        //     '/' +
        //     selectedDate.object.day
        // );
        setselectedDateValueString(dateVal);
        setSelectedDateValue(selectedDate.object);
        onChange(selectedDate.date);
    }

    return (
        <>
            <div
                style={{
                    direction: 'rtl',
                    margin: 'auto',
                }}
                className="yekanBakhFaNum"
            >
                <CustomisedTextField
                    icon={<CalendarMonthIcon style={{ color: 'var(--primary-text-color)' }} />}
                    value={selectedDateValueString}
                    placeholder={placeHolder}
                    label={label}
                    onChange={() => { }}
                    onclick={() => {
                        setShowPicker(true);
                    }}
                    onFocus={(e: any) => e.target.blur()}
                />

                {selectedDateValue ? (
                    <div className="autocomplete-none-text">
                        <Picker
                            title={placeHolder}
                            isOpen={showPicker}
                            config={config}
                            minDate={newDate({ year: 1310, month: 1, day: 1 })}
                            maxDate={newDate({ year: 1440, month: 12, day: 29 })}
                            onSubmit={handleSubmit}
                            initialValue={newDate({
                                year: selectedDateValue.year,
                                month: selectedDateValue.month,
                                day: selectedDateValue.day,
                            })}
                            onClose={() => setShowPicker(false)}
                            highlightWeekends

                        />
                    </div>
                ) : (
                    <div className="autocomplete-none-text">

                        <Picker
                            title={placeHolder}
                            isOpen={showPicker}
                            config={config}
                            minDate={newDate({ year: 1310, month: 1, day: 1 })}
                            maxDate={newDate({ year: 1440, month: 12, day: 29 })}
                            onSubmit={handleSubmit}
                            onClose={() => setShowPicker(false)}
                            highlightWeekends
                        />
                    </div>
                )}
            </div>
        </>
    );
}
